var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-divider "},[_c('div',{class:("line-divider__line line-divider__line--" + _vm.spacing + " line-divider__line--" + _vm.color)})])}
var staticRenderFns = []

export { render, staticRenderFns }